import { GlobalState } from '../../store/types';

export const getSettings = (state: GlobalState) => state.settings;
